import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMouseDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mouse-down, press, depth, deep-dive"><path d="M16 11L11.9999 15L8 11" stroke="currentColor" strokeWidth="1.5"/><path d="M12 14.5V4" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M18.6711 10.5498C20.5662 11.4676 21.75 12.7719 21.75 14.2188C21.75 16.9974 17.3848 19.2498 12 19.2498C6.61522 19.2498 2.25 16.9974 2.25 14.2188C2.25 12.7719 3.43381 11.4676 5.32895 10.5498" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMouseDown;
